import { Document } from "../objects/Document.interface";
import { DocumentService } from "../services/Documents.service";
import { getDocumentId, getHigherNumber, getTitleDocument, parseStringToArrayBuffer, ReadFile, removeNonPrintableCharacters } from '../tools/Utils';
import { Annotation } from '../objects/Annotation.interface';
import { AnnotationService } from '../services/Annotations.service';
import { ReadFileToText } from "./FileReader";
import { Entity } from "../objects/Entity.interface";
import { ImportData } from "./ImportData";

const _documentService: DocumentService = new DocumentService();
const _annotationService: AnnotationService = new AnnotationService();
const _importService = new ImportData();

export class FileParser{

    
    constructor(){

    }

    async parseFiles(files:File[], projectId:number, documents:Document[]){
        var cont: number = 0;
        var documentIds: number[] = documents.map(item => item.id);
        for(cont; cont< files.length; cont++)
        {
            var documentContent = await ReadFile(files[cont]);
            documentContent = removeNonPrintableCharacters(documentContent);
            var newId = getHigherNumber(documentIds) + cont;
            var newDocument: Document = {
                title: getTitleDocument(files[cont]),
                textContent: parseStringToArrayBuffer(documentContent),
                projectId: projectId,
                isSelected: false,
                id: newId,
                sort: newId,
                placeNames: []
            }

            _documentService.add(newDocument).then(docId => {
                console.log('Document with id: '+docId+' added')
            }).catch(error => {
                console.log(error);
            });
        }
    }

    async parseAnnotationFiles(files:File[], documents:Document[], entities:Entity[]){
        var cont: number = 0;
        var newAnnotations:Annotation[] = [];
        for(cont; cont< files.length; cont++)
        {

            var documentId = getDocumentId(files[cont], documents);
            if(documentId !== -1){
                var fileContent = await ReadFileToText(files[cont]);
                let jsonData = JSON.parse(fileContent);
                
                jsonData.forEach((jsonItem:any) => {
                    var newFirstEntityId = (parseInt( jsonItem.firstEntityId) === -1)?-1:entities.find(ntt => ntt.Code === jsonItem.firstEntityCode)!.id!;
                    var newSecondEntityId = (parseInt( jsonItem.secondEntityId) === -1)?-1:entities.find(ntt => ntt.Code === jsonItem.secondEntityCode)!.id!;

                    var newAnnotation: Annotation = {
                        text: jsonItem.text,
                        start: jsonItem.start,
                        end: jsonItem.end,
                        paragraph: jsonItem.paragraph,
                        documentId: documentId,
                        firstEntityId: newFirstEntityId,
                        firstEntityCode: jsonItem.firstEntityCode,
                        secondEntityId: newSecondEntityId,
                        secondEntityCode: jsonItem.secondEntityCode,
                        fieldsFirstEntity: jsonItem.fieldsFirstEntity,
                        fieldsSecondEntity: jsonItem.fieldsSecondEntity,
                        isUniqueMode: jsonItem.isUniqueMode,
                        status: jsonItem.status,
                        relatedTo: (jsonItem.relatedTo)?jsonItem.relatedTo:-1,
                        relatedText: (jsonItem.relatedText)?jsonItem.relatedText:"",
                        relatedKey: (jsonItem.relatedKey)?jsonItem.relatedKey:""
                    }
    
                    newAnnotations.push(newAnnotation);
                });
                
            }
        }

         await _annotationService.addBulk(newAnnotations).then(async result => {
            console.log('Annotations imported');
        }).catch(error => {
            console.log(error);
        });

        documents.forEach(async document => {
            //actualizar los ids de las anotaciones relacionadas que fueron importadas
            await _importService.UpdateRelatedAnnotationsIds(document.id);
        });
        
    }
}